import { useTranslation } from 'react-i18next';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { ChevronRight } from 'lucide-react';
import { INDUSTRIES, COMPANY_SIZES } from '@/lib/calculationEngine';

/**
 * Step 1 — collects industry + company size before the questionnaire begins.
 */
export function ProfileStep({
  industry,
  setIndustry,
  companySize,
  setCompanySize,
  totalSteps,
  canProceed,
  onNext,
}) {
  const { t } = useTranslation();
  return (
    <Card className="bg-white border-[#DDE1E5]" data-testid="profile-step">
      <CardContent className="p-6 space-y-5">
        <div className="text-center mb-2">
          <div className="text-xs text-[#8A929B] uppercase tracking-wider mb-1">
            {t('assessment.stepOf', { current: 1, total: totalSteps })}
          </div>
          <h2 className="text-lg font-bold text-[#171A1D]" style={{ fontFamily: 'IBM Plex Sans, sans-serif' }}>
            {t('assessment.companyProfile')}
          </h2>
        </div>
        <div className="space-y-4">
          <div>
            <Label className="text-[#66707A] text-sm mb-1.5 block">{t('assessment.industry')}</Label>
            <Select value={industry} onValueChange={setIndustry}>
              <SelectTrigger aria-label={t('assessment.industry')} className="bg-white border-[#DDE1E5] text-[#171A1D]" data-testid="industry-select">
                <SelectValue placeholder={t('assessment.selectIndustry')} />
              </SelectTrigger>
              <SelectContent className="bg-white border-[#DDE1E5]">
                {INDUSTRIES.map(i => (
                  <SelectItem key={i.value} value={i.value} className="text-[#171A1D] focus:bg-[#F5F6F7]">
                    {t('calcData.industries.' + i.value)}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          <div>
            <Label className="text-[#66707A] text-sm mb-1.5 block">{t('assessment.companySize')}</Label>
            <Select value={companySize} onValueChange={setCompanySize}>
              <SelectTrigger aria-label={t('assessment.companySize')} className="bg-white border-[#DDE1E5] text-[#171A1D]" data-testid="size-select">
                <SelectValue placeholder={t('assessment.selectSize')} />
              </SelectTrigger>
              <SelectContent className="bg-white border-[#DDE1E5]">
                {COMPANY_SIZES.map(s => (
                  <SelectItem key={s.value} value={s.value} className="text-[#171A1D] focus:bg-[#F5F6F7]">
                    {t('calcData.sizes.' + s.value)}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        </div>
        <Button
          className="w-full h-11 bg-[#527F19] hover:bg-[#3F6114] text-white font-semibold"
          disabled={!canProceed}
          onClick={onNext}
          data-testid="next-btn"
        >
          {t('assessment.startAssessment')} <ChevronRight className="w-4 h-4 ml-1" />
        </Button>
      </CardContent>
    </Card>
  );
}
